import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/webSetting',
  component: Layout,
  redirect: '/webSetting/index',
  name: 'WebSetting',
  meta: {
    title: '网站设置管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'WebSettingIndex',
      component: () => import('@/views/webSetting/index.vue'),
      meta: {
        title: '网站设置管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/webSetting"
      },
    }
  ],
}

export default routes
